import React, { useContext, useEffect, useRef, useState } from 'react'
import ReactToPrint from 'react-to-print';
import { useTranslation } from 'react-i18next';
// import { useSelector } from 'react-redux';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import PrintReport from './PrintReport';
import BGLogoSimple from '../../../assets/images/BGLogoSimple.png';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

function PrintInboundMappingData(props) {
    // const [records, setRecords] = useState([]);
    const printRef = useRef(null);
    const { openModal, toggle } = props;
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    // const { templateHeader: header, condition: details } = useSelector(state => state.treeData[parentScreen].rightTree.tree);
    // const { rightTree } = useSelector(state => state.treeData[parentScreen]);
    // const [headers, setHeaders] = useState([rightTree.tree.header.translatedData?.[0]]);
    // const [body, setBody] = useState([rightTree.tree.body.translatedData?.[0]]);
    // const [trailer, setTrailer] = useState([rightTree.tree.trailer.translatedData?.[0]]);
    // const types = ['RECORD', 'FIELD_GROUP', 'RECORD_TOP', 'ELEMENT', 'REPEATING_ELEMENT', 'QUERY', 'COMMENT'];

    const handleCancelClick = () => {
        toggle();
    }

    // const getRecords = (rootNode) => {
    //     let records = [];

    //     const loopRecord = (node) => {
    //         if (node?.type === "root") node.children.forEach(o => loopRecord(o));
    //         if (types.includes(node?.type)) {
    //             records.push({ Type: node.DESCRIPTION || node.type, value: node.DESCRIPTION || node.title, Length: node?.length || 0, Parent: node?.PARENT || '' });
    //             if (node?.children.length) node.children.forEach(o => loopRecord(o));
    //         }
    //     }

    //     loopRecord(rootNode);
    //     return records
    // }

    // const getRecordConditions = (rootNode) => {
    //     let conditionRecords = [];
    //     const loopRecord = (node) => {
    //         if (node.CONDITION) node.CONDITION.forEach(condition => loopRecord(condition));
    //         if (types.includes(node?.Type)) {
    //             conditionRecords.push({ ...node })
    //         }
    //     }

    //     loopRecord(rootNode)
    //     return conditionRecords;
    // }

    // const getFieldsForRecord = (rootNode, record) => {
    //     if (!rootNode || !record) return [];
    //     let fields = [];

    //     const checkNode = (node) => {
    //         if (node.type === record) {
    //             node.children.forEach((o, k) => {
    //                 if (o.type === "FIELD") {
    //                     fields.push({ ...o.FIELD, text: o.title })
    //                 }
    //                 else if (o.type === "RECORD") {
    //                     const records = getRecords(o)?.map((record) => getFieldsForRecord(o, record.title));
    //                     records.forEach((record) => {
    //                         fields.push(...record)
    //                     })
    //                 }
    //             })
    //             return true;
    //         }
    //         return false;
    //     }

    //     const searchNode = (node) => {
    //         node.children.every((o) => {
    //             if (checkNode(o)) return false; //pushes fields, exits loop
    //             if (o.children.length) searchNode(o);
    //             return true
    //         })
    //     }

    //     if (checkNode(rootNode)) return fields;
    //     if (rootNode.children?.length) searchNode(rootNode);
    //     return fields;
    // }

    // const handleRecords = () => {
    //     let recordsDetails = [];
    //     recordsDetails.push(...getRecords(rightTree.tree.header.translatedData?.[0]));
    //     recordsDetails.push(...getRecords(rightTree.tree.body.translatedData?.[0]));
    //     recordsDetails.push(...getRecords(rightTree.tree.trailer.translatedData?.[0]));
    //     setRecords(recordsDetails)
    // }

    const handlePrint = () => {
        return <Button size="small" variant="outlined" color="primary"> {t('BTN_PRINT_INBOUND_REPORT')} </Button>
    }

    useEffect(() => {
        // setHeaders(rightTree.tree.header.translatedData?.[0]);
        // setBody(rightTree.tree.body.translatedData?.[0]);
        // setTrailer(rightTree.tree.trailer.translatedData?.[0]);
        // handleRecords()
    }, [openModal])

    return (
        <>
            <Dialog open={openModal} fullWidth={true} maxWidth='md' scroll='paper' >
                <DialogContent>
                    <div ref={printRef}>
                    <div>
                        <img src={BGLogoSimple} alt='BridgeGate logo' className='bg-logo-default' />
                        <p className='col-header'>
                            {t('LBL_INBOUND_TEMPLATE_REPORT')}
                        </p>
                    </div>
                    <div style={{
                        border: '1px solid black',
                        padding: '1rem'
                    }}>
                        <p>{t('CONTENT_UNDER_CONSTRUCTION')}</p>
                    </div>
                        {/* <div className='divider-top'>
                            <span className='col-header'> {t('LBL_TEMPLATE_PROPS')} </span>
                            <PrintReport headers={header} />
                        </div> */}
                        {/* <div>
                            {
                                details?.map((detail, index) => {
                                    return (
                                        <>
                                            {detail.FIELD_NAME && detail.CONDITION && <span className='col-header' key={index}>
                                                {t('LBL_RECORD_MAPPING_CONDITIONS')} {t(detail.FIELD_NAME)}
                                            </span>
                                            }
                                            {
                                                getRecordConditions(detail).map((condition, index) => {
                                                    return <div>
                                                        {condition.FIELD_NAME && <span className='col-header' key={index}>
                                                            {t('LBL_RECORD_MAPPING_CONDITIONS')} {t(condition.FIELD_NAME)}
                                                        </span>}
                                                        <PrintReport headers={condition} />
                                                    </div>
                                                })
                                            }
                                        </>
                                    )
                                })
                            }
                        </div> */}
                        {/* <div>
                            <span className="col-header"> {t('LBL_REC_LISTING')} </span>
                            {
                                <ul>
                                    {
                                        records?.map((record, index) => <li key={index}><a className='list-item' href={`#${record.value}`}>{record.value}</a></li>)
                                    }
                                </ul>
                            }
                        </div> */}
                        {/* <div>
                            {
                                records.length > 0 && <div>
                                    {
                                        records?.map((record, index) => {
                                            return <div key={index}>
                                                <span className='col-header' id={record?.value}>
                                                    {t('LBL_REC_TYPE')} {record?.value}
                                                </span>
                                                <PrintReport headers={record} />
                                                {
                                                    <>
                                                        <span className='col-header'>
                                                            {t('LBL_FLDS')}
                                                        </span>
                                                        {
                                                            getFieldsForRecord(headers, record?.Type)?.map((field, idx1) => <PrintReport headers={field} key={`${index + 1 + idx1}`} />)
                                                        }
                                                        {
                                                            getFieldsForRecord(body, record?.Type)?.map((field, idx2) => <PrintReport headers={field} key={index + 2 + idx2} />)
                                                        }
                                                        {
                                                            getFieldsForRecord(trailer, record?.Type)?.map((field, idx3) => <PrintReport headers={field} key={index + 3 + idx3} />)
                                                        }
                                                    </>
                                                }
                                            </div>
                                        })
                                    }
                                </div>
                            }
                        </div> */}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={() => handleCancelClick()}
                    > {t('CANCEL')}
                    </Button>
                    <ReactToPrint
                        bodyClass='padding-16'
                        trigger={() => handlePrint()}
                        content={() => printRef.current}
                    />
                </DialogActions>
            </Dialog>
        </>
    )
}

export default PrintInboundMappingData;